import CarsService from "../shared/services/carsService";
import { carsStatuses } from "./../components/sections/cars/static.carsStatuses";

const REQUEST_CARS = "REQUEST_CARS";
const RESPONSE_CARS = "RESPONSE_CARS";
const REQUEST_CARS_FAILURE = "REQUEST_CARS_FAILURE";

const requestOptionsCarsFilter = (options = {}) => {
  let nextOptions = Object.assign({}, options, {
    types: [],
    brands: [],
    groups: [],
    statuses: [],
    winterCompanies: [],
    sensors: [],
  });

  if (!!options.types) nextOptions.types = options.types.map((item) => item.value);

  if (!!options.brands) nextOptions.brands = options.brands.map((item) => item.value);

  if (!!options.groups) nextOptions.groups = options.groups.map((item) => item.value);

  if (!!options.winterCompanies)
    nextOptions.winterCompanies =
      options.winterCompanies.length === 0 && options._currentWintrerCompanies !== undefined
        ? options._currentWintrerCompanies.map((x) => {
            return x.value;
          })
        : options.winterCompanies.map((x) => {
            return x.value;
          });

  if (!!options.sensors) nextOptions.sensors = options.sensors.map((item) => item);

  if (!!options[carsStatuses.inmotion.name]) nextOptions.statuses.push(carsStatuses.inmotion.id);

  if (!!options[carsStatuses.parking.name]) nextOptions.statuses.push(carsStatuses.parking.id);

  if (!!options[carsStatuses.loss.name]) nextOptions.statuses.push(carsStatuses.loss.id);

  return nextOptions;
};

const requestGetCarsAction = () => {
  return {
    type: REQUEST_CARS,
  };
};

const responseGetCarsAction = (data) => {
  return {
    type: RESPONSE_CARS,
    data,
  };
};

const requestGetCarsfailureAction = (errors) => {
  return {
    type: REQUEST_CARS_FAILURE,
    errors,
  };
};

const getCars = (filterOptions) => {
  return (dispatch) => {
    dispatch(requestGetCarsAction());

    let responsesCount = 0;
    let errors = [];

    const winterCompaniesUnits = {
      filterCount: 0,
      isBookmarkCount: 0,
      total: 0,
      units: [],
      winterCompanies: [],
    };

    async function addCompanyUnits(data, isError = false) {
      if (!isError) {
        responsesCount++;
        winterCompaniesUnits.total += data.total;
        winterCompaniesUnits.filterCount += data.filterCount;
        winterCompaniesUnits.isBookmarkCount += data.isBookmarkCount;
        winterCompaniesUnits.units = winterCompaniesUnits.units.concat(data.units);
      } else {
        errors = errors.concat(data);
      }

      const count = responsesCount + errors.length;

      if (count === 1) {
        dispatch(responseGetCarsAction(winterCompaniesUnits));
        //     dispatch(newNotification({ id: uuidv4(), title: "s", text: "Не удалось получить данные, повторите запрос после", level: 3 }));
      }
    }

    CarsService.getCars(requestOptionsCarsFilter(filterOptions))
      .then((result) => {
        addCompanyUnits(result.data);
      })
      .catch((error) => {
        addCompanyUnits(error.response, true);

        // dispatch(requestGetCarsfailureAction(error.response));

        // if (error.response && error.response.status === 401) {
        //   dispatch(setLogout());
        // }
      });

    // winterCompanies.forEach((company) => {
    //   filterOptions.winterCompanyId = company.value;

    //   CarsService.getCars(requestOptionsCarsFilter(filterOptions))
    //     .then((result) => {
    //       addCompanyUnits(result.data);
    //     })
    //     .catch((error) => {
    //       addCompanyUnits(error.response, true);

    //       // dispatch(requestGetCarsfailureAction(error.response));

    //       // if (error.response && error.response.status === 401) {
    //       //   dispatch(setLogout());
    //       // }
    //     });
    // });
  };
};

export {
  getCars,
  requestGetCarsAction,
  responseGetCarsAction,
  requestGetCarsfailureAction,
  REQUEST_CARS,
  RESPONSE_CARS,
  REQUEST_CARS_FAILURE,
};
